import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GrowlService } from '../service/growl.service';

@Injectable()
export class AccessDeniedInterceptor implements HttpInterceptor {

    constructor(private growlService: GrowlService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req)
            .pipe(
                catchError((err: any) => {
                    if (err instanceof HttpErrorResponse && err.status === 403) {
                        this.growlService.showErrorGrowl('ERROR.403');
                    }
                    return throwError(err);
                })
            );
    }
}
